import { render, staticRenderFns } from "./slsdgc.vue?vue&type=template&id=204d70c5&"
import script from "./slsdgc.vue?vue&type=script&lang=js&"
export * from "./slsdgc.vue?vue&type=script&lang=js&"
import style0 from "./slsdgc.vue?vue&type=style&index=0&id=204d70c5&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports